export const initialFilterState = ({ searchKey, searchType }) => ({
  startDate: null,
  endDate: null,
  cashinStatus: "",
  cashinChannel: "all",
  cashinMethod: "all",
  searchKey,
  searchType,
  mode: "",
  page: 1,
  perPage: 10,
});
